import {PairSide} from '@/components/shared/PairToggle.vue'
import {MarkKind, MARKS} from '@/utils/propertyDefinition'
import {MessageKey} from '@/i18n'

/** Uma escolha de dois lados do Comportamento: o que se escolhe, o lado desligado e o ligado. */
export type Pair = { label: string, off: PairSide, on: PairSide }

/**
 * Um par pelas chaves dos textos: o rótulo, e o rótulo e a frase de cada lado. O lado ligado tem o ícone e a
 * cor da marca (`MARKS`), os mesmos dos selos da lista. Um dono para o Comportamento e o Preenchimento.
 */
export function pairOf(tt: (key: MessageKey) => unknown, kind: MarkKind, label: MessageKey,
                       off: [MessageKey, MessageKey], on: [MessageKey, MessageKey]): Pair {
    return {
        label: tt(label) as string,
        off: {label: tt(off[0]) as string, hint: tt(off[1]) as string},
        on: {label: tt(on[0]) as string, hint: tt(on[1]) as string, ...MARKS[kind]}
    }
}
